
export class ItemFilter {
    Id: number;
}

export class ListFilter extends ItemFilter {
    PageNumber?: number;
    PageSize?: number;
    Ids: number[];
    TopN?: number;
}

export class CompanyUserFilter extends ListFilter {

}

export class CompanyUserInviteFilter extends ListFilter {

}

export class ListingFilter extends ListFilter {
    AgentId?: number;
}

export enum SortType {
    ASC = "ASC",
    DESC = "DESC"
}
